import React from 'react';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs, { BreadcrumbsProps } from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import T from 'i18n-react';
import CategoryChip from '../../core/News/CategoryChip';
import Article from '../../core/Articles/Article';
import { NEWS_INDEX } from '../routing';
import type { ArticleProps } from '../../core/Articles/props';
import withStyles from '@material-ui/core/styles/withStyles';

const StyledBreadcrumbs: React.FC<BreadcrumbsProps> = withStyles({
  ol: {
    flexWrap: 'nowrap',
  },
})(Breadcrumbs);

const Show = ({
  subject,
  announcedAt,
  backgroundImageUrl,
  category = {},
  body,
}: ArticleProps) => {
  return (
    <Article
      loaded
      subject={subject}
      body={body}
      backgroundImageUrl={backgroundImageUrl}
      announcedAt={announcedAt}
      breadcrumbs={
        <StyledBreadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href={NEWS_INDEX} variant="body2" noWrap>
            {T.translate('title.news.index')}
          </Link>
          <Typography
            color="textPrimary"
            variant="body2"
            className="line-truncate-1"
          >
            {subject}
          </Typography>
        </StyledBreadcrumbs>
      }
      categoryChip={<CategoryChip {...category} />}
    />
  );
};

export default Show;
